import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { PAGE_PATH_NAME } from '../utils/const';

// 本カスタムフックの返却値
type UsePageTitleValue = {
  // ページのタイトル
  pageTitle: string;
};

const usePageTitle = (): UsePageTitleValue => {
  // ページのタイトル
  const [pageTitle, setPageTitle] = useState<string>('SuperELMer');
  // location
  const { pathname } = useLocation();

  useEffect(() => {
    switch (pathname) {
      case PAGE_PATH_NAME.SERIAL_INPUT:
        setPageTitle('SuperELMer - Activation');

        return;

      case PAGE_PATH_NAME.LESSON:
        setPageTitle('SuperELMer - Home');

        return;

      case PAGE_PATH_NAME.TRAINING:
        setPageTitle('SuperELMer - Training');

        return;

      default:
        break;
    }

    setPageTitle('SuperELMer');
  }, [pathname]);

  return {
    pageTitle,
  };
};

export default usePageTitle;
